//
//
//
//
//
//
//
import CollegeView01 from "@/components/statistical/college/CollegeView01";
import ForLink from "@/components/statistical/ForLink";
export default {
  name: "College",
  components: {
    CollegeView01: CollegeView01,
    ForLink: ForLink
  },
  props: [],
  data: function data() {
    return {};
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {},
  watch: {},
  filters: {}
};